import { type MouseEvent, type ReactNode, useState } from 'react'

import { documentContentUrl, opensInPreview } from '@/components/AgentChat/previewDocument'
import { DocumentPreviewDialog } from '@/components/documents/DocumentPreviewDialog'
import { cn } from '@/lib/utils'

interface DocumentPreviewLinkProps {
  documentId: string
  attachmentId?: string | null
  fileName: string
  /** The dialog's heading: what the Documents tab calls the file. */
  title: string
  className?: string
  children: ReactNode
}

/** An image, PDF or spreadsheet opens in a dialog; Cmd/Ctrl-click, or any other file, opens it in a new tab. */
export function DocumentPreviewLink({
  documentId,
  attachmentId,
  fileName,
  title,
  className,
  children,
}: DocumentPreviewLinkProps) {
  const [open, setOpen] = useState(false)
  const doc = { documentId, attachmentId, fileName }

  function handleClick(event: MouseEvent<HTMLAnchorElement>) {
    if (!opensInPreview(event, fileName)) return
    event.preventDefault()
    setOpen(true)
  }

  return (
    <>
      <a
        href={documentContentUrl(doc)}
        target="_blank"
        rel="noopener noreferrer"
        onClick={handleClick}
        className={cn('font-medium text-blue-600 hover:underline', className)}
      >
        {children}
      </a>
      {open && <DocumentPreviewDialog doc={doc} title={title} onOpenChange={setOpen} />}
    </>
  )
}
